// Auto-generated by tools/splitLocaleFiles.ts.
// Serves as both the runtime bootstrap bundle for en-GB and the single source
// of type truth for MessageKey. When you add a new domain file under
// src/locales/en-GB/, re-run the split script (or add the import + field
// manually here).

import _misc from "./en-GB/_misc.json";
import auditLog from "./en-GB/auditLog.json";
import auth from "./en-GB/auth.json";
import banner from "./en-GB/banner.json";
import club from "./en-GB/club.json";
import coach from "./en-GB/coach.json";
import dashboard from "./en-GB/dashboard.json";
import gallery from "./en-GB/gallery.json";
import general from "./en-GB/general.json";
import league from "./en-GB/league.json";
import leagueRanking from "./en-GB/leagueRanking.json";
import leagueSetup from "./en-GB/leagueSetup.json";
import license from "./en-GB/license.json";
import maintenance from "./en-GB/maintenance.json";
import managementTeam from "./en-GB/managementTeam.json";
import match from "./en-GB/match.json";
import news from "./en-GB/news.json";
import onboarding from "./en-GB/onboarding.json";
import organization from "./en-GB/organization.json";
import pages from "./en-GB/pages.json";
import partner from "./en-GB/partner.json";
import partnerGroup from "./en-GB/partnerGroup.json";
import payment from "./en-GB/payment.json";
import platform from "./en-GB/platform.json";
import platformDocument from "./en-GB/platformDocument.json";
import purchasedLicense from "./en-GB/purchasedLicense.json";
import question from "./en-GB/question.json";
import ranking from "./en-GB/ranking.json";
import rankingCategory from "./en-GB/rankingCategory.json";
import rankingPoint from "./en-GB/rankingPoint.json";
import sport from "./en-GB/sport.json";
import stripeConnect from "./en-GB/stripeConnect.json";
import team from "./en-GB/team.json";
import terminology from "./en-GB/terminology.json";
import tour from "./en-GB/tour.json";
import tournament from "./en-GB/tournament.json";
import transaction from "./en-GB/transaction.json";
import user from "./en-GB/user.json";

export const enGB = {
  auditLog,
  auth,
  banner,
  club,
  coach,
  dashboard,
  gallery,
  general,
  league,
  leagueRanking,
  leagueSetup,
  license,
  maintenance,
  managementTeam,
  match,
  news,
  onboarding,
  organization,
  pages,
  partner,
  partnerGroup,
  payment,
  platform,
  platformDocument,
  purchasedLicense,
  question,
  ranking,
  rankingCategory,
  rankingPoint,
  sport,
  stripeConnect,
  team,
  terminology,
  tour,
  tournament,
  transaction,
  user,
  ..._misc,
};

export type EnGBMessages = typeof enGB;
